/**
 * Ролі робочого простору в порядку вибору (core.workspace_member.role). Підписи на сторінках «Учасники» й «Запрошення» — як у прототипі v4
 * (ROLES сторінки members: Owner, Admin, Member, Viewer → «Власник, Адміністратор, Депутат, Глядач»; membersPage.roleNames).
 */
export const ROLES: readonly string[] = ['Owner', 'Admin', 'Member', 'Guest'];
